<template>
    <i :class="['message-icon', 'el-icon-s-comment', hereList.length > 0 ? 'message-icon-active' : '']" @click="showDialog = true">
        <span class="message-count">{{ hereList.length > 0 ? `${hereList.length}` : '' }}</span>
        <el-dialog :title="$t('TABLE_HEADER_Message')"
            top="10vh"
            :visible="showDialog"
            width="45%"
            :close-on-click-modal="false"
            append-to-body
            @close="showDialog = false">
            <div class="messageViewer">
                <template v-if="hereList && hereList.length>0" :loading="loading">
                    <el-row class="itemWarp" v-for="(item, index) in hereList" :key="item.id">
                        <el-col :span="18" :class="item.sendUserType == getUser.userType ? 'floatRight' : 'floatLeft'">
                            <el-avatar :class="item.sendUserType == getUser.userType ? 'floatRight' : 'floatLeft'" size="small" :src="circleUrl"></el-avatar>
                            <div class="messageWarp" :class="item.sendUserType == getUser.userType ? 'floatRight' : 'floatLeft'">
                                <div class="messageBy">
                                    {{ item.sendUserName }}【<span>{{item.createDate | formatDateTime}}</span>】
                                </div>
                                <div class="messageContent" :class="item.sendUserType == getUser.userType ? 'rightMessage' : 'leftMessage'">
                                    {{ item.message }}
                                    <el-popconfirm v-if="item.sendUserId === getUser.userId"
                                                :title="$t('msg_delete_sure')" @confirm="deleteMessage(item, index)">
                                        <i slot="reference" class="el-icon-delete deleteButton leftButton"></i>
                                    </el-popconfirm>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </template>
                <span v-else style="margin-top: 20px">{{$t('INSIGHTS_NO_DATA')}}</span>
            </div>
            <div class="addMessage">
                <el-input
                        type="textarea"
                        resize="none"
                        maxlength="300"
                        show-word-limit
                        :rows="3"
                        :placeholder="$t('ENTER_MESSAGE_CONTENT')"
                        v-model="input"
                        @keyup.enter.exact.native="onSendCommit">
                </el-input>
                <i :title="$t('comment_send')" class="el-icon-s-promotion wl-icon-send" @click="onSendCommit"></i>
            </div>
        </el-dialog>
    </i>
    <!-- <el-popover
        placement="left-start"
        width="500"
        trigger="click">
        <i slot="reference" :class="['message-icon', 'el-icon-s-comment', hereList.length > 0 ? 'message-icon-active' : '']">
            <span class="message-count">{{ hereList.length > 0 ? `${hereList.length}` : '' }}</span>
        </i>
        <div class="commentPopover" v-loading="loading">
            <div class="list">
                <div
                    class="message-row"
                    v-for="(v, k) in hereList"
                    :key="k">
                    <div class="sender">
                        <div class="sender-name">{{ v.sendUserName }}</div>
                        <div class="send-time">{{ v.createDate | formatDateTime }}</div>
                    </div>
                    <div class="message">{{ v.message }}</div>
                </div>
            </div>
            <div class="input-row">
                <el-input class="input" v-model="input" clearable></el-input>
                <el-button class="send-btn wl-green" @click="onSendCommit">{{ $t('comment_send') }}</el-button>
            </div>
        </div>
    </el-popover> -->
</template>
<script>
import API from '@/api'
import { mapGetters } from "vuex"

export default {
    name: 'CommentPopover',
    data() {return {
        circleUrl: require('@/assets/img/messageboard1.png'),
        input: '',
        hereList: [],
        loading: false,
        showDialog: false
    }},
    props: {
        messageList: {
            type: Array,
            default: () => []
        },
        summaryId: {
            type: String,
            default: ''
        },
        questionId: {
            type: String,
            default: ''
        }
    },
    mounted() {
        this.hereList = JSON.parse(JSON.stringify(this.messageList.sort((a, b) => Date.parse(new Date(a.createDate)) - Date.parse(new Date(b.createDate)))))
        this.setScorll()
    },
    methods: {
        async deleteMessage(item, index) {
            try {
                const params = {
                    ids: [item.id]
                }
                const { data, code } = await API.exchange.ituDeleteMessage(params)
                if (code == '1') {
                    this.$message.success(this.$t('msg_success'))
                    this.hereList.splice(index, 1)
                } else {
                    this.$message.error(this.$t(code))
                }
            }
            catch(e) {}
            finally {
                // this.onAdd()
            }
        },
        onSendCommit() {
            if (!this.input || !this.input.replaceAll(' ', '')) {
                this.$message.error(this.$t('MESSAGE_ERROR01'))
                return
            }
            this.loading = true
            API.exchange.ituSendMessage({
                summaryId: this.summaryId,
                questionId: this.questionId,
                message: this.input
            }).then(res => {
                if (res.code == '1') {
                    let userName = ''
                    if (this.getUser.userType == '1') {
                        userName = `${this.getUser.userName}(${this.getUser.profitCenter})`
                    }
                    if (this.getUser.userType == '2') {
                        userName = this.getUser.userName
                    }

                    this.hereList.push({
                        sendUserName: userName,
                        createDate: (new Date()).toString(),
                        message: this.input,
                        sendUserType: this.getUser.userType,
                        sendUserId: this.getUser.userId
                    })

                    this.input = ''
                } else {
                    this.$message.error(this.$t(res.code))
                }
            }).finally(() => {
                this.loading = false
                this.setScorll()
            })
        },
        setScorll() {
            const ele = document.getElementsByClassName('messageViewer')[0]
            if (!ele || !ele.scrollHeight) return
            const timer = setTimeout(function() {
                if (ele.scrollHeight > ele.clientHeight) {
                    //设置滚动条到最底部
                    ele.scrollTop = ele.scrollHeight
                }
                ele.style.opacity = 1
                this.loading = false
                if (timer) {
                    clearTimeout(timer)
                }
            }, 100)
        }
    },
    computed: {
        ...mapGetters('common', {
            getSite: 'getSite',
            getUser: 'getUser',
            getEntityIds: 'getEntityIds',
        }),
    },
    watch: {
        messageList(v) {
            this.hereList = v
        },
        hereList(v) {
            this.$emit('update:messageList', v)
        }
    }
}
</script>
<style scoped>
.message-icon {
    font-size: 22px;
    color: #ccced2;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.message-icon-active {
    color: #3879eb;
}
.message-icon .message-count {
    font-size: 13px;
    color: #3879eb;
    margin-left: 5px;
}
.messageViewer {
    padding: 10px;
    border: #e9e9eb 1PX solid;
    border-radius: 5px 5px 0 0;
    border-bottom: none;
    background: #f9f9f9;
    height: 50vh;
    overflow-y: scroll;
    text-align: center;
}

.itemWarp {
    margin-bottom: 5px;
}

.messageWarp {
    padding: 0 10px;
    max-width: 80%;
}

.messageBy {
    line-height: 20px;
    position: relative;
}

.messageContent {
    padding: 8px 5px;
    line-height: 25px;
    border-radius: 5px;
    text-align: left;
    position: relative;
    word-break: break-word
}

.floatLeft {
    float: left;
    text-align: left;
}

.floatRight {
    float: right;
    text-align: right;
}

.leftMessage {
    background: #a8c8e7;
    border: #a8c8e7 1PX solid;
}

.rightMessage {
    background: #ffffff;
    border: #8c939d 1PX solid;
}

.addMessage {
    border: #e9e9eb 1PX solid;
    border-radius: 0 0 5px 5px;
    position: relative;
    padding-bottom: 36px;
}

.addMessage ::v-deep .el-textarea__inner {
    border: none;
}

.addMessage ::v-deep .el-textarea__inner:hover {
    border: none;
}

.wl-icon-send {
    font-size: 20px;
    line-height: 26px;
    padding: 0 3px;
    background-color: #409EFF;
    color: #ffffff;
    border-radius: 13px;
    border: #409EFF 1PX solid;
    cursor: pointer;
    position: absolute;
    bottom: 10px;
    right: 10px;
}

.deleteButton {
    position: absolute;
    top: calc(50% - 7px);
    cursor: pointer;
    color: #dd6161;
}

.leftButton {
    left: -20px;
}

.rightButton {
    right: -20px;
}
/* .commentPopover {
    display: flex;
    flex-direction: column;
}
.commentPopover .input-row {
    display: flex;
    flex-direction: row;
    align-items: center;
}
.commentPopover .input-row .input {
    
}
.commentPopover .input-row .send-btn {
    margin-left: 10px;
}
.commentPopover .list {
    display: flex;
    flex-direction: column;
    max-height: 200px;
    overflow-y: scroll;
}

.commentPopover .list .message-row {
    display: flex;
    flex-direction: column;
    margin-bottom: 15px;
}
.commentPopover .list .message-row .sender {
    display: flex;
    flex-direction: row;
    font-size: 13px;
}
.commentPopover .list .message-row .sender .sender-name {
    font-weight: 600;
}
.commentPopover .list .message-row .sender .send-time {
    margin-left: 10px;
    color: gray;
}
.commentPopover .list .message-row .message {
    font-size: 18px;
} */
</style>